module.exports = __webpack_public_path__ + "static/img/pic.d6118d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic.png
// module id = o3Ya
// module chunks = 1